import { Registry$1_$ctor_Z1FA48BC9 } from "./Omnicv.Shared/ModulesRegistration.js";
import { DiaryClientModule_$ctor } from "./modules/Omnicv.Diary.Client/DiaryClientModule.js";
import { PhysicalClientModule_$ctor } from "./PhysicalClientModule.js";
import { FinancialClientModule_$ctor } from "./FinancialClientModule.js";
import { FitnessClientModule_$ctor } from "./FitnessClientModule.js";
import { ofArray } from "./fable_modules/fable-library-js.4.24.0/List.js";

export const clientModuleRegistry = Registry$1_$ctor_Z1FA48BC9(ofArray([DiaryClientModule_$ctor(), PhysicalClientModule_$ctor(), FinancialClientModule_$ctor(), FitnessClientModule_$ctor()]));

